export function LeftArrow() {
  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 22 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.28225 1.12436L6.19182 1.21905L0.749637 7.56826C0.0826883 8.34636 0.0456356 9.47399 0.638479 10.2909L0.749637 10.4317L6.19182 16.7809C6.62312 17.2841 7.38068 17.3424 7.88387 16.9111C8.35352 16.5086 8.43559 15.8218 8.09378 15.3229L8.01403 15.2191L3.71211 10.2L20.5791 10.2C21.2419 10.2 21.7791 9.66274 21.7791 9C21.7791 8.37868 21.3069 7.86765 20.7018 7.8062L20.5791 7.8L3.71211 7.79998L8.01403 2.78095C8.41658 2.3113 8.39266 1.62008 7.97857 1.17933L7.88387 1.08889C7.41423 0.686339 6.723 0.710265 6.28225 1.12436Z"
        fill="currentColor"
      />
    </svg>
  );
}
